import Vue from 'vue';
import moment from 'moment'

Vue.filter('dateFormatFromNow', function (date) {
  return moment(date).fromNow()
})
Vue.filter('dateFormatString', function (date) {
  try {
    let formatted_date = moment(date).format('D MMM, YYYY')
    if (formatted_date == 'Invalid date') {
      return date;
    }
    return formatted_date;
  } catch (e) {
    return date;
  }
})
Vue.filter('dateFormatShortString', function (date) {
  try {
    let formatted_date = moment(date).format('MMM, YYYY')
    return formatted_date
  } catch (e) {
    return date
  }
})
Vue.filter('dateTimeDynamicFormat', function (date, format = 'D MMM, YYYY h:mm A') {
  try {
    let formatted_date = moment(date).format(format)
    return formatted_date
  } catch (e) {
    return date
  }
})
Vue.filter('dateTimeFormatString', function (date) {
  return moment(date).format('D MMM, YYYY h:mm A')
})
Vue.filter('timeFormatString', function (date) {
  return moment(date).format('h:mm A')
})
Vue.filter('dateDiffDays', function (date) {
  return moment().diff(date, 'days')
})
Vue.filter('moneyFormatter', function (number) {
  if (number === null || isNaN(number)) {
    number = 0
  }
  return parseFloat(number).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
})
Vue.filter('fixNumberFormat', function (number) {
  return parseFloat(number).toFixed(0)
})
Vue.filter('formatNRIC', function (nric) {
	if(_gHlp.isEmpty(nric)) return nric;

  if (nric.length !== 12) {
    return nric;
  }

  var x = nric.substr(0, 6);
  var y = nric.substr(6, 2);
  var z = nric.substr(8, 4);

  return x + '-' + y + '-' + z;
})
Vue.filter('formatUserName', function (text, count = false) {
  let lower_case = text.toLowerCase();
  let capitalize = lower_case.replace(/\b\w/g, function (match) {
    return match.toUpperCase();
  });

  if (count && capitalize.length > count) {
    capitalize = capitalize.slice(0, count) + "...";
  }

  return capitalize;
})
Vue.filter('shortenText', function (text, count = false) {
  if (count && text.length > count) {
    text = text.slice(0, count) + "...";
  }
  return text;
})
Vue.filter('initial', function (name) {
  const names = name.split(' ');
  let initials = '';
  const maxInitials = 3;
  for (let i = 0; i < names.length && i < maxInitials; i++) {
    initials += names[i].charAt(0);
  }
  return initials;
})